import Types from "Types";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetAdbRegroupement } from "../../../hooks/AdministrateurDeBien";
import {
  useGetFonctionsPostes,
  usePutUtilisateur,
} from "../../../hooks/Utilisateurs";
import { Selectors as AdbSelectors } from "../../../redux/AdministrateurDeBien";
import { Selectors as UtilisateursSelectors } from "../../../redux/Utilisateurs";
import { Utilisateur } from "../../../services/Api/swagger";

export const useModifierUtilisateur = () => {
  const utilisateurConnecte = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateurConnecte(state),
  );
  const adbId = useSelector((state: Types.RootState) =>
    AdbSelectors.getAdbId(state),
  );
  const adbSelectedDetail = useSelector((state: Types.RootState) =>
    AdbSelectors.getSelectedAdbDetail(state),
  );

  const utilisateur = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateur(state),
  );
  const isChargeClienteleBesse = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.isChargeClienteleBesse(state),
  );
  const {
    data: fonctionsPostes,
    error: fonctionsPostesError,
    isFetching: fonctionsPostesFetching,
  } = useGetFonctionsPostes();
  const { mutate: mutateAdbRegroupement, data: adbRegroupementList } =
    useGetAdbRegroupement();

  const getADBRegroupementList = (params: number) => {
    mutateAdbRegroupement(params);
  };

  const selectedAdb = useSelector((state: Types.RootState) =>
    AdbSelectors.getADBDetail(state),
  );
  const {
    mutate: mutateModifierUtilisateur,
    isLoading: utilisateurFetching,
    error: utilisateurError,
    reset: resetPutUtilisateur,
  } = usePutUtilisateur();
  const modifierUtilisateur = (param: {
    username: string;
    body: Utilisateur;
  }) => {
    mutateModifierUtilisateur(param);
  };

  useEffect(() => {
    if (utilisateurConnecte && utilisateurConnecte.role === "BESSE" && adbId) {
      getADBRegroupementList(adbId);
    }
  }, [utilisateurConnecte, adbId]);

  return {
    fonctionsPostes,
    getADBRegroupementList,
    adbRegroupementList,
    selectedAdb,
    modifierUtilisateur,
    adbId,
    adbSelectedDetail,
    fonctionsPostesError,
    utilisateurConnecte,
    utilisateurFetching,
    utilisateurError,
    fonctionsPostesFetching,
    resetPutUtilisateur,
    utilisateur,
    isChargeClienteleBesse,
  };
};
